import React, { useEffect, useState } from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import { TableColumnWidthsContext } from "./Table.context";
import { TableCell, TableCellProps } from "./TableCell";
import { TableHeader, TableHeaderProps } from "./TableHeader";
import { TablePagination, TablePaginationProps } from "./TablePagination";
import { TableRow, TableRowProps } from "./TableRow";
import { TooltipWrapper, TooltipWrapperProps } from "./TooltipWrapper";

import styles from "./Table.module.css";

interface TableComposition {
  Header: React.FC<TableHeaderProps>;
  Row: React.FC<TableRowProps>;
  Cell: React.FC<TableCellProps>;
  Pagination: React.FC<TablePaginationProps>;
  TooltipWrapper: React.FC<TooltipWrapperProps>;
}

interface TableProps {
  children: React.ReactNode;
  className?: string;
  initialColumnWidths?: string[];
  externalStorage?: Storage;
  externalStorageKey?: string;
}

/* eslint-disable react/prop-types  */
export const Table: React.FC<TableProps> & TableComposition = ({
  children,
  className,
  initialColumnWidths = [],
  externalStorage,
  externalStorageKey,
}) => {
  const [columnWidths, setColumnWidths] =
    useState<string[]>(initialColumnWidths);

  useEffect(() => {
    if (externalStorage && externalStorageKey) {
      externalStorage.setItem(externalStorageKey, JSON.stringify(columnWidths));
    }
  }, [columnWidths, externalStorage, externalStorageKey]);

  return (
    <TableColumnWidthsContext.Provider
      value={{ columnWidths, setColumnWidths }}
    >
      <div
        className={toClassName(styles.gridContainer, className)}
        style={{ gridTemplateColumns: columnWidths.join(" ") }}
      >
        {children}
      </div>
    </TableColumnWidthsContext.Provider>
  );
};

// NOTE: compound components
Table.Header = TableHeader;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Pagination = TablePagination;
Table.TooltipWrapper = TooltipWrapper;
